import { render, staticRenderFns } from "./mini-gantt-chart-v2.vue?vue&type=template&id=589882c5&scoped=true&"
import script from "./mini-gantt-chart-v2.component.ts?vue&type=script&lang=ts&"
export * from "./mini-gantt-chart-v2.component.ts?vue&type=script&lang=ts&"
import style0 from "./mini-gantt-chart-v2.scss?vue&type=style&index=0&id=589882c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589882c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589882c5')) {
      api.createRecord('589882c5', component.options)
    } else {
      api.reload('589882c5', component.options)
    }
    module.hot.accept("./mini-gantt-chart-v2.vue?vue&type=template&id=589882c5&scoped=true&", function () {
      api.rerender('589882c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mini-gantt-chart-v2/mini-gantt-chart-v2.vue"
export default component.exports